import { render, staticRenderFns } from "./EmojiPicker.vue?vue&type=template&id=67723eb8"
import script from "./EmojiPicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmojiPicker.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports